export default __webpack_public_path__ + "static/sparkle-pay-illustration-b6e9a4090ab4bf62dd973057def64a35.svg";